<template>
<!-- heyan -->
  <section class="wechat-authorization-index">
    <el-tabs v-model="activeTab">
      <template v-for="(item, index) in tabs">
        <el-tab-pane :label="item.label" :name="item.name" :key="index">
          <label slot="label">{{item.label}}<jee-icon iconClass="caozuoshuoming1" :style="{fontSize: '16px'}"/></label>
          <component :is="item.component" :name="activeTab"></component>
        </el-tab-pane>
      </template>
    </el-tabs>
  </section>
</template>

<script>
import wechatPublic from './WechatPublic'
import wechatApplet from './WechatApplet'
export default {
  name: 'socialWechatAuthorizationIndex',
  components: {
    wechatPublic,
    wechatApplet
  },
  data () {
    return {
      activeTab: 'wechatPublic',
      tabs: [
        {
          label: '微信公众号',
          name: 'wechatPublic',
          component: 'wechatPublic'
        },
        {
          label: '微信小程序',
          name: 'wechatApplet',
          component: 'wechatApplet'
        }
      ]
    }
  }
}
</script>
